export default {
    // Currently used
    home_search_for_product: "Αναζητήστε το προϊόν σας",
    conventional_alternative: "Εναλλακτικό συμβατικό",
    led_alternative: "Εναλλακτικό LED",
    search_filters_filter: "Φίλτρο",
    alt_filters_filter: "Φίλτρο αντίστοιχου προϊόντος LED",
    search_submit: "Αναζήτηση προϊόντος",
    results: "Αποτελέσματα:",
    selected_product: "Επιλεγμένο προϊόν:",
    search_input: "Πληκτρολογήστε τον κωδικό προϊόντος (ή μέρος του) ή την περιγραφή",
    what_type_are_you_looking_for: "Τι είδους προϊόν αντικατάστασης ψάχνετε;",
    recommendations_singular: "Προτάσεις",
    recommendations_plural: "Προτάσεις",
    your_product: "Το προϊόν σας",
    search_filters_reset: "Επαναφορά φίλτρου",
    results_specify: "Υπάρχουν περισσότερα από 10 αποτελέσματα, παρακαλώ προσδιορίστε περαιτέρω την αναζήτησή σας",
    energy_efficient: "Ενεργειακά αποδοτικά",
    active_filters: "Ενεργά φίλτρα",
    card_action: "Κατάλογος",
    card_show_more: "Περισσότερα αποτελέσματα",
    card_show_less: "Λιγότερα αποτελέσματα",
    card_alternative_fit: "Η καλύτερη εναλλακτική πρόταση Philips ",
    card_perfect_fit: "Η καταλληλότερη πρόταση Philips",
    no_results_found: "Δεν βρέθηκαν αποτελέσματα. Παρακαλώ αναζητήστε με διαφορετικά κριτήρια",
    results_no_recommendations: "Χρειάζεστε βοήθεια; Επικοινωνήστε με τον υπεύθυνο πωλήσεων που σας εξυπηρετεί, για να βρείτε την λύση που σας ταιρίαζει.",
    led_no_recommendations: "Δεν υπάρχει αντίστοιχο προϊόν LED",
    ballast_notice: "Πρέπει να ελεγχθεί η συμβατότητα με το ηλεκτρονικό όργανο (HF ballast)",
    ballast_notice_tled_link_text: "Λίστα συμβατότητας LED Tube",
    ballast_notice_pl_led_link_text: "Λίστα συμβατότητας LED PL",
    
    // LED facets
    search_filter_product_type: "Τύπος προϊόντος",
    lighting_type: "Tύπος λαμπτήρα",
    ean: "EAN",
    product_code: "Κωδικός προϊόντος",
    eoc: "EOC",
    family: "Οικογένεια",
    discrete_wattage: "Wattage",
    wattage: "Wattage",
    brand: "Επωνυμία",
    driver_type: "Τύπος οργάνου",
    number_of_lamps: "Αριθμός λαμπτήρων",
    length: "Μήκος",
    color: "Χρώμα",
    base: "Ντουϊ",
    local_eoc: "Local Code",
    lumen: "Φωτεινή ροή (Lumen)",
    energy_saving: "Εξοικονόμησης ενέργειας",
    tiering: "Κατηγορία",
    ballast_compatibility: "Συμβατότητα με Ballast",
    lifetime: "Χρόνος ζωής",
  
    // Conventional facets
    ignitor: "Εκκινητής",
    height: "'Υψος",
    width: "Πλάτος",
    mounting_hole: "Διάσταση ανοίγματος τοποθέτησης",
    mains_voltage: "Τάση δικτύου",
    thermal_protection: "Θερμική προστασία",
    delta_temperature: "Διαφορά θερμοκρασίας",
    energy_efficiency: "Ενεργειακή αποδοτικότητα",
    losses: "Απώλειες",
    lamp_current: "Ρεύμα λαμπτήρα",
    pf_cap: "PF Cap (C)",

    /*loading: "Φόρτωση…",
    too_many_requests: "Η αναζήτησή σας είναι περιορισμένη. Συνδεθείτε με έναν λογαριασμό για να παρακάμψετε αυτόν τον περιορισμό ή δοκιμάστε ξανά αργότερα.",
    session_expired: "Η περίοδος σύνδεσης έληξε. Παρακαλούμε συνδεθείτε ξανά.",
    header_sign_out: "Αποσύνδεση",
    header_login: "Σύνδεση",
    header_help: "Βοήθεια",
    welcome_header: "Καλώς ήρθατε στο εργαλείο μετατροπής της Philips",
    welcome_copy: "Με το εργαλείο μετατροπής της Philips, είναι πολύ εύκολο να βρείτε εναλλακτικές επιλογές για οποιουσδήποτε λαμπτήρες και όργανα λειτουργίας",
    welcome_feature_1: "Βρείτε γρήγορα τα προϊόντα σας",
    welcome_feature_2: "Εύκολο περιβάλλον αναζήτησης",
    welcome_feature_3: "Βρείτε όλες τις πληροφορίες και τις προδιαγραφές που απαιτούνται για τη μετατροπή ενός προϊόντος",
    login_title: "Σύνδεση",
    login_form_username: "Ονομα χρήστη",
    login_form_password: "Κωδικός ασφαλείας",
    login_form_remember: "Επιθυμώ να παραμένω συνδεδεμένος",
    login_form_forgot_pswd: "Ξεχάσατε τον κωδικό ασφαλείας σας?",
    login_form_login: "Σύνδεση",
    login_no_account_yet: "Δεν έχετε λογαριασμό ακόμα?",
    login_request_account: "Ζητήστε λογαριασμό",
    login_skip_request_explanation: "Αν παρακάμψετε τη διαδικασία σύνδεσης (login), θα μπορείτε να βρείτε προϊόντα, αλλά με πολύ περιορισμένα στοιχεία. Δε θα έχετε τεχνικές λεπτομέρειες, σύγκριση προδιαγραφών, πολλαπλές εισόδους/εξόδους ή εξαγωγή των αποτελεσμάτων. Για να έχετε την πλήρη εμπειρία, δημιουργήστε έναν λογαριασμό και αποθηκεύστε τον κωδικό πρόσβασής σας για εύκολη πρόσβαση.",
    login_skip_login_cta: "Παρακάμψτε τη σύνδεση",
    login_credentials_invalid: "Λανθασμένη ηλεκτρονική διευθυνση (email) ή κωδικός ασφαλείας",
    login_forgot_pswd: "Ξέχασα τον κωδικό ασφαλείας μου",
    login_forgot_pswd_content_one: "Ξεχάσατε τον κωδικό ασφαλείας σας? Κανένα πρόβλημα - Εισάγετε την ηλεκτρονική διεύθυνση (email) που χρησιμοποιείτε για το λογαριασμό σας.",
    login_forgot_pswd_content_two: "Αν είστε καταχωρημένος χρήστης, θα σας σείλουμε μήνυμα (email) με τον σύνδεσμο αλλαγής κωδικού ασφαλείας.",
    login_forgot_pswd_email: "Ηλεκτρονική διευθυνση (email)",
    login_forgot_request_pswd: "Ζητήστε νέο κωδικό ασφαλείας",
    login_forgot_invalid: "Λανθασμένη ηλεκτρονική διευθυνση (email)",
    login_successful: "Επιτυχής σύνδεση",
    logout_successful: "Επιτυχής αποσύνδεση",
    home_search_for_product: "Αναζητήστε το προϊόν σας",
    home_title: "Πως λειτουργεί",
    home_subtitle: "Είναι πραγματικά πολύ εύκολο.",
    home_content_one: "Έχουμε σχεδιάσει τη γραμμή αναζήτησης με στοχο την ταχύτητα και τα γρήγορα αποτελέσματα.",
    home_content_two: "Εισάγετε (μέρος) του κωδικού προϊόντος ή της περιγραφής για να πάρετε μια πρώτη πρόταση για το επιθυμητό προϊόν. Εάν δεν διαθέτετε πληροφορίες για το προϊόν σας, χρησιμοποιήστε τα φίλτρα για να φτάσετε στο επιθυμητό προϊόν.",
    home_content_three: "Μόλις επιλέξετε ένα προϊόν, μπορείτε να ελέγξετε όλες τις πληροφορίες που απαιτούνται για τη μετατροπή. Αφού ολοκληρώσετε, μπορείτε να εξαγάγετε τα αποτελέσματα ή να αναζητήσετε το επόμενο προϊόν.",
    home_contact_us: "Επικοινωνήστε μαζί μας",
    request_account_title: "Ζητήστε λογαριασμό",
    request_account_content_one: "Με ένα λογαριασμό, έχετε πλήρη πρόσβαση στο ηλεκτρονικό εργαλείο, συμπεριλαμβανομένων όλων των χαρακτηριστικών της πολλαπλής εισαγωγής, εξαγωγής, σύγκρισης προδιαγραφών και απεριόριστων αναζητήσεων.",
    request_account_content_two: "Για να επαληθεύσουμε το λογαριασμό σας, χρειαζόμαστε κάποιες βασικές πληροφορίες για το λογαριασμό και την εταιρεία σας.",
    request_account_content_three: "Μετά την επαλήθευση, θα λάβετε το σύνδεσμο για τη δημιουργία του λογαριασμού σας.",
    request_account_personal_information: "Προσωπικές πληροφορίες",
    request_account_first_name: "Όνομα",
    request_account_last_name: "Επίθετο",
    request_account_email: "Ηλεκτρονική διευθυνση (email)",
    request_account_username: "(Αυτό θα είναι το όνομα χρήστη σας)",
    request_account_password_1: "Κωδικός ασφαλείας",
    request_account_password_2: "Επαναλάβατε τον κωδικό ασφαλείας",
    request_account_company: "Εταιρία",
    request_account_company_name: "Όνομα εταιρίας",
    request_account_country: "Χώρα",
    request_account_job: "Τίτλος επαγγέλματος",
    agree_to_privacy_policy: "Διάβασα και αποδέχομαι τους όρους χρήσης και την πολιτική απορρήτου",
    validate_all_fields_required: "Όλα τα πεδία είναι απαραίτητα.",
    validate_agree_tac: "Πρέπει να συμφωνήσετε με τους όρους και τις προϋποθέσεις χρήσης",
    validate_passwords_dont_match: "Οι κωδικοί ασφαλείας δε συμφωνούν",
    validate_password_too_short: "Ο κωδικός ασφαλείας θα πρέπει να έχει ελάχιστο μήκος 8 χαρακτήρες",
    validate_password_too_weak: "Ο κωδικός ασφαλείας σας δεν είναι αρκετά δύσκολος",
    email_already_in_use: "Υπάρχει ήδη καταχωρημένος χρήστης με αυτή την ηλεκτρονική διεύθυνση (email)",
    email_verify_in_progress: "Επιβεβαιώστε την ηλεκτρονική σας διεύθυνση (email)…",
    email_verified_success: "Η ηλεκτρονική σας διεύθυνση (email) επιβεβαιώθηκε επιτυχώς. Μπορείτε τώρα να συνδεθείτε.",
    email_verified_failed: "Λυπούμαστε, δεν μπορέσαμε να επιβεβαιώσουμε την ηλεκτρονική σας διεύθυνση (email).",
    registration_successful: "Σας εστάλη μήνυμα (email) επαλήθευσης στην ηλεκτρονική σας διεύθυνση",
    password_reset_failed: "Προέκυψε σφάλμα, παρακαλούμε δοκιμάστε ξανά αργότερα",
    password_reset_email_sent: "Σας στείλαμε μήνυμα (email) με τον σύνδεσμο αλλαγής κωδικού ασφαλείας.",
    new_password_header: "Παρακαλούμε επιλέξτε νέο κωδικό ασφαλείας",
    new_password: "Νέος κωδικός ασφαλείας",
    repeat_new_password: "Επαναλάβατε το νέο κωδικό ασφαλείας",
    save_new_password: "Φύλαξη του νέου κωδικού ασφαλείας",
    password_changed_success: "Επιτυχής αλλαγή κωδικού ασφαλείας",
    request_account_request: "Ζητήστε λογαριασμό",
    visual_input_code_title: "Εισαγωγή κωδικού/περιγραφής προϊόντος",
    visual_input_code_content: "Εισαγάγετε ένα όνομα ή κωδικό προϊόντος ή αναζητήστε με τη βοήθεια των φίλτρων.",
    visual_hit_search_title: "Πατήστε το κουμπί αναζήτησης",
    visual_hit_search_content: "Ετοιμοι? Πατήστε το κουμπί αναζήτησης για να πάρετε τα αποτελέσματα.",
    visual_select_result_title: "Επιλέξτε το αποτέλεσμά σας από το πλαίσιο προτάσεων.",
    visual_select_result_content: "Σύρετε προς τα κάτω για να ελέγξετε την προτεινόμενη εναλλακτική λύση Philips και να λάβετε όλες τις πληροφορίες που χρειάζεστε",
    search_input: "Πληκτρολογήστε (μέρος) τον κωδικό προϊόντος ή την περιγραφή",
    search_submit: "Αναζήτηση προϊόντος",
    search_filter_product_type: "Τύπος προϊοντος",
    search_filter_device: "Συσκευή",
    search_filter_color: "Χρώμα",
    search_filter_wattage: "Ισχύς (Wattage)",
    search_filter_brand: "Εμπορική επωνυμία",
    search_filter_show_all: "Εμφάνιση όλων των φίλτρων",
    search_filter_hide_all: "Απόκρυψη όλων των φίλτρων",
    search_filter_clear_all: "Καθαρισμός φίλτρων",
    results_export: "Εξαγωγή αποτελεσμάτων",
    result_export_all: "Εξαγωγή όλων των αποτελεσμάτων",
    results: "αποτελέσματα",
    results_shown: "αποτέλεσμα",
    no_results_found: "Δε βρέθηκαν αποτελέσματα. Παρακαλούμε επαναλάβατε την αναζήτηση με διαφορετικά κριτήρια",
    results_no_recommendations: "Δε βρήκατε λύση? Παρακαλούμε επικοινωνήστε με τοπικό εμπορικό εκπρόσωπο για υποστήριξη.",
    recommendations_singular: "προτεινόμενη λύση",
    recommendations_plural: "προτεινόμενες λύσεις",

    home_contact_us_content: "Should you require any further information or if you have any questions, feel free to contact us and we will be glad to assist you.",
    home_contact_us_first_name: "Όνομα",
    home_contact_us_last_name: "Επίθετο",
    home_contact_us_email: "Ηλεκτρονική διευθυνση (email)",
    home_contact_us_message: "Message",
    home_contact_us_submit: "Submit",
    home_contact_us_successfully: "Your message is successfully sent.",
    home_contact_us_error: "Something went wrong, please try again.",
    usage_disclaimer: "Intended only for the use of qualified Philips customers.",
    search_filter_bulb_finish: "Bulb finish",
    search_filter_bulb: "Bulb",
    search_filter_ignitor: "Ignitor",
    search_filter_packaging_configuration: "Packaging configuration",
    search_filter_fixture_feature: "Fixture feature",
    search_filter_base: "base",
    total_number_results: "Total number of results",
    results_specify: "There are more than 10 results, please further specify your search",

    //facets
    brand: "Εμπορική επωνυμία",
    wattage: "Ισχύς (Wattage)",
    type: "Type",
    color: "Χρώμα",
    bulb_finish: "Bulb finish",
    subfamily: "Subfamily",
    bulb: "Bulb",
    ignitor: "Ignitor",
    packaging_configuration: "Packaging configuration",
    fixture_feature: "Fixture feature",
    family: "Family",
    base: "Base",
    pf_cap: "PF cap",
    number_of_lamps: "Number of lamps",
    lamp_current: "Lamp current",
    mains_frequency: "Mains frequency",
    driver_type: "Driver type",
    mains_voltage: "Mains voltage",
    height: "Height",
    weight: "Weight",
    thermal_protection: "Thermal protection",
    losses: "Losses",
    temp_range: "Temperature range",
    delta_temperature: "Delta temperature",
    life_class_tw: "Life class TW",
    wiring_diagram: "Wiring diagram",
    width: "Width",
    length: "Length",
    type_of_lamp: "Type of lamp",
    mounting_hole: "Mounting hole",
    power_factor: "Power factory",
    energy_efficiency: "Energy efficiency",
    product_description: "Product description",

    //Match and result props
    apr: "APR",
    ean: "EAN",
    eu: "EU",
    latam: "Latam",
    material_description: "Material description",
    nam: "NAM",
    // product_code: "12NC",
    product_code: "Product code",
    remark: "Remark",
    valid: "Valid",

    card_action: "Catalogue",
    card_perfect_fit: "Philips Best Fit",
    card_alternative_fit: "Philips Best Alternative",
    card_show_more: "Show more",
    card_show_less: "Show less"*/
};
